import { Order } from "../../CRUDs/entities/Order";
import categories from "../../organizations/services-management/categories/categories";
import { Customer } from "../../CRUDs/entities/Customer";

export const ordersModalActionsListners = (target, actionsWindow) => {

    actionsWindow.find('.action').off()

    const orderId = target.parent().data('id')
    const customerId = target.parent().data('customer-id')
    const order = new Order(orderId)
    let result = order.read()
    let workers = result?.worker_details ? result.worker_details : []

    let actionWorkersText = workers.length ? workers.map(worker=>worker?.first_name+' '+worker?.last_name).join(', ') : 'Assign Workers'

    actionsWindow.find('.action.workers').text(actionWorkersText)
    actionsWindow.find('.action.workers').on('click', ev =>{
        order.openModal('assing_workers')
    })

    actionsWindow.find('.subscription').text(result?.from_subscription ? 'Yes' : 'No')

    const statusAction = actionsWindow.find('.action.statuses')
    statusAction.find('.current').text(statusAction.find(`.order-action-statuses [data-value=${result?.status}]`).text())
    statusAction.find('.current').off('click').on('click', ()=>{
        statusAction.find(`.order-action-statuses`).toggleClass('d-none')
    })
    statusAction.find(`.order-action-statuses .status-item`).off('click').on('click', ev=>{

        const changeStatusBlick = (selectElement, success=true) => {
            const successColor = '#85D700';
            const errorColor = '#E10000';
            const defaultColor = 'none';
            const resultColor = success ? successColor : errorColor;
            selectElement.css('background', resultColor);
            setTimeout(() => {
                selectElement.css('background', defaultColor);
                setTimeout(()=>statusAction.find(`.order-action-statuses`).addClass('d-none'),200)
            }, 100);

        }
        const status = $(ev.currentTarget).data('value');

        $.ajax({
            url: `${location.origin}/order/${orderId}/change-status`,
            data: { status },
            method: 'POST',
            success: () => {
                changeStatusBlick($(ev.currentTarget));
                statusAction.find('.current').text(statusAction.find(`.order-action-statuses [data-value=${status}]`).text())
            },
            error: () => {
                changeStatusBlick($(ev.currentTarget), false);
            }
        });
    })

    actionsWindow.find('.action.attach-pics').on('click', ev=>{
        order.openDropZone()
    })
    actionsWindow.find('.action.order-info').on('click', ev=>{
        $.ajax({
            type: 'GET',
            url: '/services-management/categories/get-additional-form',
            data: {
                id: orderId,
                type: 'appointment',
            },
            success: (response) => {
                $('#form-container').html(response);
                $('#view-details-form-modal').modal('show');
            },
            error: (response) => {
                console.log(response);
            },
        });
    })
    actionsWindow.find('.action.reschedule').on('click', ev=>{
        $.ajax({
            type: 'GET',
            url: '/reschedule/order/get-form/' + orderId,
            success: function (response) {
                $('#form-container').html(response);
                $('#reschedule-modal').modal('show');
                categories.dateStartChange();
            }
        });
    })
    actionsWindow.find('.action.customer-info').on('click', ev=>{
        let customer = new Customer(customerId);
        $.ajax({
            type: 'GET',
            url: `/customers/form?entity=customer&type=contact&id=${customerId}&form-request=true`,
            success: (response) => {
                $('#form-container').html(response);
                $('#contact-customer-modal').modal('show');
                $('#customer-info-edit-customer').on('click', e => {
                    e.preventDefault();
                    customer.openModal('edit', { id: customerId });
                });
            }
        });
    })
}

